export default "__VITE_ASSET__BWuh82Qc__"